import { useEffect, useRef, useState } from 'react';

export default function HeroVideo() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleCanPlay = () => {
      video.play()
        .then(() => setIsPlaying(true))
        .catch(() => setIsPlaying(false));
    };

    video.addEventListener('canplay', handleCanPlay);
    
    if (video.readyState >= 3) {
      handleCanPlay();
    }

    return () => {
      video.removeEventListener('canplay', handleCanPlay);
    };
  }, []);

  return (
    <section className="video-container relative overflow-hidden">
      {/* Poster - video тоглох хүртэл харагдана */}
      <img
        src="/media/bodios_small.png"
        alt="Bodios"
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
          isPlaying ? 'opacity-0 pointer-events-none' : 'opacity-100'
        }`}
      />

      {/* Video */}
      <video
        ref={videoRef}
        className={`object-cover w-full aspect-[3/4] sm:aspect-[16/9] transition-opacity duration-700 ${
          isPlaying ? 'opacity-100' : 'opacity-0'
        }`}
        muted
        playsInline
        loop
        preload="auto"
      >
        <source src="/media/hero_vid.mp4" type="video/mp4" />
      </video>
    </section>
  );
}